import React, { useState, useEffect } from 'react';
import './GroupParam.css';
import PositiveIcon from '../media/imagen/posismile.svg';
import NegativeIcon from '../media/imagen/badsmile.svg';
import NeutralIcon from '../media/imagen/neutralsmile.svg';
import PoyStatus from '../media/imagen/PoyStatus.svg';
import './LiderResult.css';
import Line from '../media/imagen/Line 95.svg';

// Компонент для отображения шкалы
const ProgressScale = ({ title, score }) => {
  const maxScore = 20;
  const totalBars = 20;
  const filledCount = Math.min(score, maxScore);
  
  // Функция для вычисления цвета
  const getBarColor = () => {
    if (score === 0) return '#CCD3DE';
    if (score >= maxScore) return '#1A62CE';
    
    const startColor = { r: 197, g: 220, b: 255 };
    const endColor = { r: 26, g: 98, b: 206 };
    
    // Рассчитываем соотношение для градиента
    const ratio = (score - 1) / (maxScore - 1);
    
    const r = Math.round(startColor.r + ratio * (endColor.r - startColor.r));
    const g = Math.round(startColor.g + ratio * (endColor.g - startColor.g));
    const b = Math.round(startColor.b + ratio * (endColor.b - startColor.b));
    
    return `rgb(${r}, ${g}, ${b})`;
  };

  const barColor = getBarColor();
  const displayScore = Number.isInteger(score) ? score : score.toFixed(1);

  return (
    <div className="scale-container">
      <div className="scale-title">{title}</div>
      <div className="scale-bars">
        {Array.from({ length: totalBars }).map((_, index) => (
          <div 
            key={index}
            className="scale-bar"
            style={{
              backgroundColor: index < filledCount ? barColor : '#F0F4F8',
            }}
          />
        ))}
      </div>
      <div className="scale-score">{displayScore}</div>
    </div>
  );
};

// Основной компонент
const LiderResult = ({ testID }) => {
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [testData, setTestData] = useState(null);
  const [userResults, setUserResults] = useState([]);

  // Тексты для уровней
  const levelTexts = {
    high: "Имеет высокий уровень коммуникативных и организационных умений, таких как умение повести за собой, стать организатором и вдохновителем жизни в коллективе, умение управлять собой, умение решать проблемы, умение влиять на окружающих, умение работать с группой.",
    medium: "Имеет средний уровень коммуникативных и организационных умений. Способен проявлять лидерские качества в знакомых ситуациях, но может испытывать трудности в новых условиях. Дальнейшее развитие поможет более эффективно осуществлять управленческие функции.",
    low: "Имеет низкий уровень коммуникативных и организационных умений и будет испытывать трудности в осуществлении управленческой роли. Не обладает умением повести за собой, стать организатором и вдохновителем жизни в коллективе, умением управлять собой, умением решать проблемы, умением влиять на окружающих, умением работать с группой и другими качествами лидера."
  };

  // Маппинг шкал
  const scalesMapping = {
    'А': 'Умение управлять собой',
    'Б': 'Осознание цели (знаю, чего хочу)',
    'В': 'Умение решать проблемы',
    'Г': 'Наличие творческого подхода',
    'Д': 'Влияние на окружающих',
    'Е': 'Знание правил организаторской работы',
    'Ж': 'Организаторские способности',
    'З': 'Умение работать с группой'
  };

  // Порядок отображения шкал
  const scaleOrder = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З'];

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error('Токен авторизации не найден');

        const response = await fetch(
          `http://185.250.149.189:8000/api/v1/Results/Leadership?test_id=${testID}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Token ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
        const result = await response.json();
        setStatusData(result);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchStatusData();
  }, [testID]);

    useEffect(() => {
        console.log(statusData)
    }, [statusData]);

  useEffect(() => {
    const fetchTestData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error('Токен авторизации не найден');

        const response = await fetch(`http://185.250.149.189:8000/api/v1/Test?id=${testID}`, {
          headers: { 'Authorization': `Token ${token}` }
        });

        if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
        
        const data = await response.json();
        
        if (!data.tests || data.tests.length === 0) {
          throw new Error('Тест не найден');
        }
        
        const test = data.tests[0];
        setTestData(test);

      } catch (error) {
        console.error('Ошибка загрузки данных теста:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestData();
  }, [testID]);


  // Объединяем данные из двух запросов
  useEffect(() => {
    if (statusData && testData) {
      const combinedData = statusData.results.map(result => {
        // Находим пользователя в группе
        const user = testData.group.users.find(u => u.user_id === result.user_id);
        const userName = user ? user.user_name : `Пользователь ${result.user_id}`;
        
        // Рассчитываем средний балл
        const scores = Object.values(result.result);
        const averageScore = scores.reduce((sum, score) => sum + score, 0) / scores.length;
        
        // Определяем уровень
        let level;
        if (averageScore >= 16) level = 'high';
        else if (averageScore >= 11) level = 'medium';
        else level = 'low';
        
        return {
          user_id: result.user_id,
          user_name: userName,
          result: result.result,
          averageScore,
          level
        };
      });
      
      setUserResults(combinedData);
    }
  }, [statusData, testData]);

  if (loading) return <div className="loading">Загрузка данных...</div>;
  if (error) return <div className="error">Ошибка: {error}</div>;
  if (!statusData || !testData) return <div className="no-data">Нет данных для отображения</div>;

  return (
    <div className="scales-block">
      {userResults.map(user => (
        <div className='LiderResultContainer' key={user.user_id}>
          <div className='PersonalLiderResultDes'>
            <h2>{user.user_name}</h2>
            <div className='Integralball'>
              <div className='IntegraText1'>
                Интегральный балл
                <span>{user.averageScore.toFixed(1)}</span>
              </div>
              <img src={Line} alt="Разделитель" />
              <div className='IntegraText2'>
                Уровень развития лидерских качеств
                <span>
                  {user.level === 'high' ? 'Высокий' : 
                   user.level === 'medium' ? 'Средний' : 'Низкий'}
                </span>
              </div>
            </div>
            <span className='LiderResult-help'>{levelTexts[user.level]}</span>
          </div>

          <div className='ProgressLiderResult'> 
            <h3>Результаты теста</h3>
            {scaleOrder.map(key => (
              <ProgressScale 
                key={key}
                title={scalesMapping[key]}
                score={user.result[key]}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LiderResult;